export default {
  Order: 1,
  Increment: 2,
  Position: 3,
  Department: 4,
  SalaryGrade: 5,
};
